export const SET_FRANCHISEES = 'franchisees/set';
export const EDIT_FRANCHISEE = 'franchisees/edit';
export const SET_QUERY = 'franchisees/setQuery';
export const RESET_QUERY = 'franchisees/resetQuery';
export const SET_LOADING = 'franchisees/setLoading';
